import { Box, Modal } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AddButtonRound from "../Buttons/AddButtonRound";
import AddIntakeForm from "../forms/AddIntakeForm";
import AddReleaseOfInformationForm from "../forms/AddReleaseOfInformationForm";
import AddGeneralLiabilityForm from "../forms/AddGeneralLiabilityForm";
import AddInformedConsentForm from "../forms/AddInformedConsentForm";
import AddConfidentialityPolicy from "../forms/AddConfidentialityPolicy";
import AddPsychiatristServicesForm from "../forms/AddPsychiatristServicesForm";
import AddClientRights from "../forms/AddClientRights";
import AddAgressionControl from "../forms/AddAgressionControl";
import TitleIntake from "../Titles/TitleIntake";
import FormLine2 from "../Lines/FormLine2";
import { format } from "date-fns";
import FormLine3 from "../Lines/FormLine3";
import FormLineIC from "../Lines/FormLineIC";
import FormLinePSC from "../Lines/FormLinePSC";
import FormLineCP from "../Lines/FormLineCP";
import FormLineCR from "../Lines/FormLineCR";
import FormLineACP from "../Lines/FormLineACP";
import FormLineTitle from "../Lines/FormLineTitle";
import { collection, doc, getDoc, onSnapshot, query } from "firebase/firestore";
import { db } from "../../firebase";
import { incrementDailyReads } from "../../logsComponents/incrementDailyReads";
import TitleMediumRoi from "../Titles/TitleMediumRoi";
import FormLineRoi from "../FormLineRoi";
import UpdloaderRoi from "../Updloader/UpdloaderRoi";
import AddDressCodeForm from "../forms/AddDressCodeForm";
import FormLineDressCode from "../Lines/FormLineDressCode";
import AddTreatmentEngagementForm from "../forms/AddTreatmentEngagementForm";
import FormLineTreatmentEngagment from "../Lines/FormLineTreatmentEngagment";
import UploaderAraEncapsulated from "../Updloader/UploaderAraEncapsulated";
import Title2 from "../Titles/Title2";
import AddPoliticalViewsForm from "../forms/AddPoliticalViewsForm";
import StandardDrawer from "../forms/StandardDrawer";
import FormLinePoliticalViews from "../Lines/FormLinePoliticalViews";
import AddAustralianSuperannuationForm from "../forms/AddAustralianSuperannuationForm";
import FormLine4 from "../Lines/FormLine4";
import AddConsentAgreementUnsupervisedActivityGood from "../forms/AddConsentAgreementUnsupervisedActivityGood";

import FormLineClientOrientationChecklist from "../Lines/FormLineClientOrientationChecklist";
import AddClientOrientationChecklist from "../forms/AddClientOrientationChecklist";
import AddClientIntakeAndBagSearchChecklist from "../forms/AddClientIntakeAndBagSearchChecklist";
import FormLineIntakeAndBagSearchList from "../Lines/FormLineIntakeAndBagSearchList";
import "../../css/clientFormsRedesign.css";

function Forms(props) {

  const styleModalGeneral2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 850,
    height: "80%",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleModalUploadPdf = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    height: "auto",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  // const { clientId } = props;

  const prevClientIdRef = useRef();

  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [clientDataRoi, setClientDataRoi] = useState([]);
  const [clientId, setClientId] = useState(props.clientId || "");
  const [openIntakeForm, setOpenIntakeForm] = useState(false);
  const [
    openAustralianSuperAnnuationForm,
    setOpenAustralianSuperAnnuationForm,
  ] = useState(false);
  const [openRoiForm, setOpenRoiForm] = useState(false);
  const [openGeneralLiabilityForm, setOpenGeneralLiabilityForm] =
    useState(false);
  const [openInformedConsentForm, setOpenInformedConsentForm] = useState(false);
  const [openPsychiatricServicesForm, setOpenPsychiatricServicesForm] =
    useState(false);
  const [openConfidentialityPolicyForm, setOpenConfidentialityPolicyForm] =
    useState(false);
  const [openClientRightsForm, setOpenClientRightsForm] = useState(false);
  const [openAgressionPolicyForm, setOpenAgressionPolicyForm] = useState(false);
  const [openDressCodePolicy, setOpenDressCodePolicy] = useState(false);
  const [openUploadRoi, setOpenUploadRoi] = useState(false);
  const [openTreatmentEngagment, setOpenTreatmentEngagment] = useState(false);
  const [openPoliticalViews, setOpenPoliticalViews] = useState(false);

  const [openIntakeForm2, setOpenIntakeForm2] = useState(false);
  const [openClientOrientationChecklist, setopenClientOrientationChecklist] =
    useState(false);

  const [
    openClientIntakeAndBagSearchChecklist,
    setopenClientIntakeAndBagSearchChecklist,
  ] = useState(false);

  const handleOpenTreatmentEngagmentForm = () =>
    setOpenTreatmentEngagment(true);
  const handleCloseTreatmentEngagmentForm = () =>
    setOpenTreatmentEngagment(false);

  const handleOpenPoliticalViewsForm = () => setOpenPoliticalViews(true);
  const handleClosePoliticalViewsForm = () => setOpenPoliticalViews(false);
  const handleCloseUploadDoc = () => setOpenUploadRoi(false);
  const handleOpenIntakeForm = () => setOpenIntakeForm(true);

  const handleOpenClientOrientationCheckList = () =>
    setopenClientOrientationChecklist(true);
  const handleCloseClientOrientationCheckList = () =>
    setopenClientOrientationChecklist(false);

  const handleClientIntakeAndBagSearchChecklis = () =>
    setopenClientIntakeAndBagSearchChecklist(false);

  const handleOpenIntakeAndBagSearchChecklist = () =>
    setopenClientIntakeAndBagSearchChecklist(true);

  const handleOpenAustralianSuperAnnuationForm = () =>
    setOpenAustralianSuperAnnuationForm(true);
  const handleCloseAustralianSuperAnnuationForm = () =>
    setOpenAustralianSuperAnnuationForm(false);

  const handleOpenRoiForm = () => setOpenRoiForm(true);
  const handleOpenGeneralLiabilityForm = () =>
    setOpenGeneralLiabilityForm(true);
  const handleOpenInformedConsentForm = () => setOpenInformedConsentForm(true);
  const handleOpenPsychiatricServicesForm = () =>
    setOpenPsychiatricServicesForm(true);
  const handleOpenConfidentialityPolicyForm = () =>
    setOpenConfidentialityPolicyForm(true);
  const handleOpenClientRightsForm = () => setOpenClientRightsForm(true);
  const handleOpenAgressionPolicyForm = () => setOpenAgressionPolicyForm(true);
  const handleOpenDressCodePolicyForm = () => setOpenDressCodePolicy(true);

  const handleCloseIntakeForm = () => setOpenIntakeForm(false);
  const handleCloseIntakeForm2 = () => setOpenIntakeForm2(false);
  const handleCloseRoiForm = () => setOpenRoiForm(false);
  const handleCloseGeneralLiabilityForm = () =>
    setOpenGeneralLiabilityForm(false);
  const handleCloseInformedConsentForm = () =>
    setOpenInformedConsentForm(false);
  const handleClosePsychiatricServicesForm = () =>
    setOpenPsychiatricServicesForm(false);
  const handleCloseConfidentialityPolicyForm = () =>
    setOpenConfidentialityPolicyForm(false);
  const handleCloseClientRightsForm = () => setOpenClientRightsForm(false);
  const handleCloseAgressionPolicyForm = () =>
    setOpenAgressionPolicyForm(false);
  const handleCloseDressCodePolicyForm = () => setOpenDressCodePolicy(false);

  useEffect(() => {
    setClientId(props.clientId || "");
  }, [props.selectedTherapist]);

  useEffect(() => {
    setClientId(props.clientId || "");
  }, [props.clientId]);

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy"); // "d" pour le jour, "MMMM" pour le mois en texte, "yyyy" pour l'année
  }

  useEffect(() => {}, [clientDataRoi]);

  useEffect(() => {
    let unsubscribe;

    const fetchData = async () => {
      try {
        const roiDocRef = doc(db, "roi", clientId);
        const roiDocSnap = await getDoc(roiDocRef);

        if (roiDocSnap.exists()) {
          const roiCollectionRef = collection(roiDocRef, "subcollection");

          // Utilisez onSnapshot pour écouter les modifications en temps réel
          unsubscribe = onSnapshot(
            roiCollectionRef,
            (roiCollectionSnapshot) => {
              if (roiCollectionSnapshot.empty) {
                // Si la sous-collection est vide, réinitialisez clientDataRoi à un tableau vide

                setClientDataRoi([]);
              } else {
                const data = roiCollectionSnapshot.docs.map((doc) => ({
                  id: doc.id,
                  ...doc.data(),
                }));
                setClientDataRoi(data);
              }
            },
            (error) => {
              console.error("Error getting subcollection: ", error);
              setClientDataRoi([]);
            }
          );
        } else {
          // Si roiDocSnap n'existe pas, réinitialisez également clientDataRoi à un tableau vide
          setClientDataRoi([]);
        }
      } catch (e) {
        console.error("Error fetching client data: ", e);
      }
    };

    if (clientId && clientId !== prevClientIdRef.current) {
      fetchData();
    }

    prevClientIdRef.current = clientId;

    // Retournez la fonction de désinscription pour nettoyer l'effet
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [clientId]);

  useEffect(() => {}, [triggerUpdate]);

  console.log("Duration of Stay in form component:", props?.durationOfStay);

  useEffect(() => {
    let unsubscribe;

    if (clientId) {
      const roiCollectionRef = collection(db, "roi");

      unsubscribe = onSnapshot(roiCollectionRef, (snapshot) => {
        // Vérifiez si un document avec le clientId correspondant a été ajouté
        const newRoiDoc = snapshot
          .docChanges()
          .find(
            (change) => change.type === "added" && change.doc.id === clientId
          );

        if (newRoiDoc) {
          setTriggerUpdate((prevState) => !prevState);
        }
        try { incrementDailyReads("profile_forms_roiCollection", snapshot.size); } catch {}
      });
    }

    // Retournez la fonction de désinscription pour nettoyer l'effet
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [clientId]);

  const [, setDocumentOfSubcollection] = useState([]);

  useEffect(() => {
    const roiDocument = doc(db, "roi", clientId);
    const subcollectionQuery = query(collection(roiDocument, "subcollection"));

    const unsubscribe = onSnapshot(subcollectionQuery, (snapshot) => {
      const newDocumentOfSubcollection = snapshot.docs.map((doc) => ({
        id: doc.id,
        data: doc.data(),
      }));

      setDocumentOfSubcollection(newDocumentOfSubcollection);
      try { incrementDailyReads("profile_forms_roi_subcollection", snapshot.size); } catch {}
    });

    return () => {
      unsubscribe();
    };
  }, [clientId]);

  console.log("props in Form: ", props);

  return (
    <div className="tab-container-white client-forms-redesign">
      <StandardDrawer
        open={openIntakeForm}
        onClose={handleCloseIntakeForm}
        className="intake-form-drawer-paper"
        contentClassName="intake-form-drawer-content"
      >
        <AddIntakeForm
          clientId={props.clientId}
          {...props}
          closemodal={handleCloseIntakeForm}
        />
      </StandardDrawer>

      <Modal
        open={openIntakeForm2}
        onClose={handleCloseIntakeForm2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <AddConsentAgreementUnsupervisedActivityGood
            clientId={props.clientId}
            {...props}
            closemodal={handleCloseIntakeForm2}
          />
        </Box>
      </Modal>

      <StandardDrawer
        open={openClientIntakeAndBagSearchChecklist}
        onClose={handleClientIntakeAndBagSearchChecklis}
        className="bag-checklist-drawer-paper"
        contentClassName="bag-checklist-drawer-content"
      >
        <AddClientIntakeAndBagSearchChecklist
          clientId={props.clientId}
          {...props}
          closemodal={handleClientIntakeAndBagSearchChecklis}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openClientOrientationChecklist}
        onClose={handleCloseClientOrientationCheckList}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddClientOrientationChecklist
          clientId={props.clientId}
          {...props}
          closemodal={handleCloseClientOrientationCheckList}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openAustralianSuperAnnuationForm}
        onClose={handleCloseAustralianSuperAnnuationForm}
      >
        <AddAustralianSuperannuationForm
          clientId={props.clientId}
          {...props}
          closemodal={handleCloseAustralianSuperAnnuationForm}
        />
      </StandardDrawer>
      <StandardDrawer
        open={openRoiForm}
        onClose={handleCloseRoiForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddReleaseOfInformationForm
          closemodal={handleCloseRoiForm}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>
      <StandardDrawer
        open={openGeneralLiabilityForm}
        onClose={handleCloseGeneralLiabilityForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddGeneralLiabilityForm
          closemodal={handleCloseGeneralLiabilityForm}
          clientId={props.clientId}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openInformedConsentForm}
        onClose={handleCloseInformedConsentForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddInformedConsentForm
          clientId={props.clientId}
          closemodal={handleCloseInformedConsentForm}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openPsychiatricServicesForm}
        onClose={handleClosePsychiatricServicesForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddPsychiatristServicesForm
          closemodal={handleClosePsychiatricServicesForm}
          clientId={props.clientId}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openConfidentialityPolicyForm}
        onClose={handleCloseConfidentialityPolicyForm}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddConfidentialityPolicy
          closemodal={handleCloseConfidentialityPolicyForm}
          clientId={props.clientId}
        />
      </StandardDrawer>

      <StandardDrawer open={openClientRightsForm} onClose={handleCloseClientRightsForm}>
        <AddClientRights closemodal={handleCloseClientRightsForm} clientId={props.clientId} {...props} />
      </StandardDrawer>

      <StandardDrawer open={openAgressionPolicyForm} onClose={handleCloseAgressionPolicyForm}>
        <AddAgressionControl closemodal={handleCloseAgressionPolicyForm} clientId={props.clientId} {...props} />
      </StandardDrawer>

      <StandardDrawer open={openDressCodePolicy} onClose={handleCloseDressCodePolicyForm}>
        <AddDressCodeForm closemodal={handleCloseDressCodePolicyForm} clientId={props.clientId} {...props} />
      </StandardDrawer>

      <Modal
        open={openUploadRoi}
        onClose={handleCloseRoiForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalUploadPdf}>
          <UpdloaderRoi {...props} closemodal={handleCloseUploadDoc} />
        </Box>
      </Modal>

      <StandardDrawer open={openTreatmentEngagment} onClose={handleCloseTreatmentEngagmentForm}>
        <AddTreatmentEngagementForm closemodal={handleCloseTreatmentEngagmentForm} clientId={props.clientId} ils={props.durationOfStay} {...props} />
      </StandardDrawer>

      <StandardDrawer open={openPoliticalViews} onClose={handleClosePoliticalViewsForm}>
        <AddPoliticalViewsForm closemodal={handleClosePoliticalViewsForm} clientId={props.clientId} {...props} />
      </StandardDrawer>

      <div className="container-main-plan margin-bottom-2">
        <div className="tab-container-title-2C">Admission form</div>
        <div className="tab-form-container-line">
          <TitleIntake />

          {props.dateOfAdmission ? (
            <FormLine2
              title="Intake form"
              color="1"
              signed={!!props.dateOfAdmission}
              dateOfAdmission={formatDate(props.dateOfAdmission)}
              {...props}
            />
          ) : (
            <FormLine2
              title="No intake form signed"
              color="1"
              signed={!!props.dateOfAdmission}
            />
          )}

          {props.dateOfAdmission ? (
            " "
          ) : (
            <AddButtonRound
              handleOpen={handleOpenIntakeForm}
              title="Add intake form"
            />
          )}
        </div>
      </div>

      <div className="container-main-plan margin-bottom-2">
        <div className="tab-container-title-2C">Intake forms</div>
        <div className="tab-form-container-line">
          <Title2 />

          {/* <FormLineConsAndAgreemOutsideActivity
            title="Consent and Agreement Form for Unsupervised Off-Site Activities"
            color="2"
            signed={props.ConsentAgreementUnsupervisedActivitiesOk}
            date={formatDate(
              props.ConsentAgreementUnsupervisedActivitiesOkSigned
            )}
            {...props}
          />
          {props.ConsentAgreementUnsupervisedActivitiesOk ? (
            ""
          ) : (
            <AddButtonRound handleOpen={handleOpenIntakeForm2} />
          )} */}

          <FormLineIntakeAndBagSearchList
            title="Client intake and bag search checklist"
            color="2"
            signed={props.clientIntakeAndBagSearchOk}
            date={formatDate(props.clientIntakeAndBagSearchDateSigned)}
            {...props}
          />
          {props.clientIntakeAndBagSearchOk ? (
            ""
          ) : (
            <AddButtonRound
              handleOpen={handleOpenIntakeAndBagSearchChecklist}
            />
          )}
        </div>
        <div className="tab-form-container-line">
          <FormLineClientOrientationChecklist
            title="Client orientation checklist"
            color="2"
            signed={props.clientOrientationCheckListOk}
            date={formatDate(props.clientOrientationCheckListDateSigned)}
            {...props}
          />
          {props.clientOrientationCheckListOk ? (
            ""
          ) : (
            <AddButtonRound handleOpen={handleOpenClientOrientationCheckList} />
          )}
        </div>
      </div>

      <div className="container-main-plan margin-bottom-2">
        <div className="tab-container-title-2C">Mandatory forms</div>

        {props.dateOfAdmission ? (
          <>
            <div className="tab-form-container-line">
              <Title2 />
              <FormLine3
                title="General liability release"
                color="2"
                signed={props.GeneralLiabilityOk}
                date={formatDate(props.GeneralLiabilityDateSigned)}
                {...props}
              />
              {props.GeneralLiabilityOk ? (
                ""
              ) : (
                <AddButtonRound handleOpen={handleOpenGeneralLiabilityForm} />
              )}
            </div>

            <div className="form-line-button">
              <FormLineIC
                title="Informed consent"
                color="1"
                signed={props.InformedConsentOk}
                date={formatDate(props.InformedConsentDateSigned)}
                {...props}
              />

              {props.InformedConsentOk ? (
                ""
              ) : (
                <AddButtonRound handleOpen={handleOpenInformedConsentForm} />
              )}
            </div>

            <div className="form-line-button">
              <FormLinePSC
                title="Psychiatric Services and Detox costs"
                color="2"
                signed={props.PsychiatristServicesOk}
                date={formatDate(props.PsychiatristServicesDateSigned)}
                {...props}
              />
              {props.PsychiatristServicesOk ? (
                ""
              ) : (
                <AddButtonRound
                  handleOpen={handleOpenPsychiatricServicesForm}
                />
              )}
            </div>

            <div className="form-line-button">
              <FormLineCP
                title="Confidentiality policy"
                color="1"
                signed={props.ConfidentialityPolicysOk}
                date={formatDate(props.ConfidentialityPolicyDateSigned)}
                {...props}
              />

              {props.ConfidentialityPolicysOk ? (
                ""
              ) : (
                <AddButtonRound
                  handleOpen={handleOpenConfidentialityPolicyForm}
                />
              )}
            </div>

            <div className="form-line-button">
              <FormLineCR
                signed={props.ClientRightsOk}
                date={formatDate(props.ClientRightsDateSigned)}
                {...props}
                title="Client rights"
                color="2"
              />
              {props.ClientRightsOk ? (
                ""
              ) : (
                <AddButtonRound handleOpen={handleOpenClientRightsForm} />
              )}
            </div>

            <div className="form-line-button">
              <FormLineACP
                title="Agression control policy"
                color="1"
                signed={props.AggressionControlPolicyOk}
                date={formatDate(props.AggressionControlPolicyDateSigned)}
                {...props}
              />
              {props.AggressionControlPolicyOk ? (
                ""
              ) : (
                <AddButtonRound handleOpen={handleOpenAgressionPolicyForm} />
              )}
            </div>
            <div className="form-line-button">
              <FormLineDressCode
                title="Dress Code Policy"
                color="1"
                signed={props.dressCodePolicyOk}
                date={formatDate(props.DressCodePolicyDateSigned)}
                {...props}
              />
              {props.dressCodePolicyOk ? (
                ""
              ) : (
                <AddButtonRound handleOpen={handleOpenDressCodePolicyForm} />
              )}
            </div>

            <div className="form-line-button">
              <FormLineTreatmentEngagment
                title="Treatment Programme Engagement Policy"
                color="1"
                signed={props.treatmentEngagementPolicyOk}
                date={formatDate(props.treatmentEngagementPolicyDateSigned)}
                {...props}
              />
              {props.treatmentEngagementPolicyOk ? (
                ""
              ) : (
                <AddButtonRound handleOpen={handleOpenTreatmentEngagmentForm} />
              )}
            </div>
            <div className="form-line-button">
              <FormLinePoliticalViews
                title="Political Views and Discrimination Policy"
                color="1"
                signed={props.politicalViewsFormOk}
                date={formatDate(props.politicalViewsDateSigned)}
                {...props}
              />
              {props.politicalViewsFormOk ? (
                ""
              ) : (
                <AddButtonRound handleOpen={handleOpenPoliticalViewsForm} />
              )}
            </div>
          </>
        ) : (
          <div className="error-discharge-message">
            Unable to add Mandatory forms if the client is not admitted.
          </div>
        )}
      </div>

      <div className="container-main-plan margin-bottom-2">
        <div className="tab-container-title-2C">Australian Superannuation</div>

        <div className="tab-form-container-line">
          <Title2 />

          {props.australianSuperannuationOk ? (
            <FormLine4
              title="Australian Superannuation"
              color="1"
              signed={!!props.australianSuperannuationOk}
              date={formatDate(props.australianSuperannuationDateSigned)}
              {...props}
            />
          ) : (
            <FormLine4
              title="No Australian Superannuation form signed"
              color="1"
              signed={!!props.australianSuperannuationDateSigned}
            />
          )}

          {props.australianSuperannuationDateSigned ? (
            " "
          ) : (
            <AddButtonRound
              handleOpen={handleOpenAustralianSuperAnnuationForm}
              title="Add Australian Superannuation form"
            />
          )}
        </div>
      </div>

      <div className="container-main-plan">
        <div className="tab-container-title-2C">
          Authorization for release of confidential information
        </div>

        {props.dateOfAdmission ? (
          <div
          //style={{ backgroundColor: "pink" }}
          >
            <div className="form-line-button-title">
              <FormLineTitle
                title="Authorization for Release of Confidential Information"
                color="2"
                {...props}
              />
              <AddButtonRound handleOpen={handleOpenRoiForm} />
              {/* <Button
                style={{ marginLeft: "25px" }}
                variant="contained"
                onClick={handleOpenUploadDoc}
              >
                UPLOAD/DOWNLOAD SCANNED FILES
              </Button> */}
            </div>

            <div className="roi-container-2bis">
              {clientDataRoi && clientDataRoi.length > 0 ? (
                <TitleMediumRoi />
              ) : (
                ""
              )}

              <div className="roi-container-2bis">
                {clientDataRoi.map((item, index) => (
                  <FormLineRoi
                    key={index}
                    title={item.companyIndividualName}
                    relationship={item.relationship}
                    signedOn={item.signedOn}
                    revoked={item.revoked}
                    {...item}
                    firstName={props.firstName}
                    lastName={props.lastName}
                    clientId={clientId}
                    subcollectionDocumentId={item.id}
                  />
                ))}
              </div>
            </div>
            <div style={{ width: "50%", marginLeft: 20 }}>
              <UploaderAraEncapsulated {...props} />
            </div>
          </div>
        ) : (
          <div className="error-discharge-message">
            Unable to add R.O.I. form if the client is not admitted.
          </div>
        )}
      </div>

      <br />
      <br />
    </div>
  );
}

export default Forms;
